import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Crown, ArrowLeft } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function AdminLoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/admin-login", { username: username.trim(), password });
      login(data);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#05070D] cx-grid-bg flex items-center justify-center px-4 relative overflow-hidden">
      <div className="pointer-events-none absolute top-1/3 left-1/2 -translate-x-1/2 h-[400px] w-[600px] rounded-full bg-red-600/10 blur-[120px]" />
      <div className="w-full max-w-md cx-glass rounded-2xl p-8 cx-fade-up" data-testid="admin-login-card">
        <Link to="/" className="text-xs text-slate-500 hover:text-slate-300 inline-flex items-center gap-1 mb-6" data-testid="admin-login-back-link">
          <ArrowLeft className="h-3 w-3" /> Siteye dön
        </Link>
        <div className="flex items-center gap-3 mb-6">
          <div className="h-11 w-11 rounded-xl bg-red-950 border border-red-500/50 flex items-center justify-center">
            <Crown className="h-5 w-5 text-red-400" />
          </div>
          <div>
            <p className="font-mono-cx text-[10px] uppercase tracking-[0.3em] text-red-400">yetkili alan</p>
            <h1 className="font-display text-2xl font-bold text-slate-50">Admin Girişi</h1>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs font-mono-cx uppercase tracking-widest text-slate-400">Kullanıcı Adı</label>
            <Input data-testid="admin-username-input" className="cx-input mt-1.5" value={username} onChange={(e) => setUsername(e.target.value)} required />
          </div>
          <div>
            <label className="text-xs font-mono-cx uppercase tracking-widest text-slate-400">Şifre</label>
            <Input data-testid="admin-password-input" type="password" className="cx-input mt-1.5" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          {error && <p data-testid="admin-login-error" className="text-sm text-red-400 bg-red-950/40 border border-red-500/40 rounded-lg px-3 py-2">{error}</p>}
          <Button data-testid="admin-login-submit" type="submit" disabled={loading} className="w-full h-11 rounded-xl bg-red-600 hover:bg-red-500 text-white font-bold">
            {loading ? "Kontrol ediliyor..." : "Panele Gir"}
          </Button>
        </form>
      </div>
    </div>
  );
}
